module.exports = __webpack_public_path__ + "static/006535-788da006c34e56f867634ab9b1ce1d4e.jpg";